import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { GameTypeListItem } from '@/models/dictionary/game-type-list.model';

export default class GetGameTypeListRequest extends ApiResourceMethod<GameTypeListItem[]> {
  public perform(): Promise<GameTypeListItem[]> {
    return this.performer.requestWithMapper(
      {},
      (payload: BaseResponse<GameTypeListItem[]>) => {
        return payload.data;
      },
    );
  }
}
